import { render, staticRenderFns } from "./AppUpgradeButton.vue?vue&type=template&id=752828d6&"
import script from "./AppUpgradeButton.vue?vue&type=script&lang=js&"
export * from "./AppUpgradeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports